// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uLKm","toggle":"styles_toggle__20vR7","preview":"styles_preview__2KiV_"};